export default {
  translation: {
    nav: {
      home: 'Home',
      trips: 'Reizen',
      aboutUs: 'Over ons',
      alerts: 'Meldingen',
      wishlist: 'Verlanglijst',
      language: 'Taal',
      profile: 'Profiel',
      settings: 'Instellingen',
      signIn: 'Inloggen',
      signUp: 'Registreren'
    },
    hero: {
      title: 'Ontdek Oeganda',
      subtitle: 'en verder',
      description: 'Ontdek de Parel van Afrika met deskundige lokale gidsen. Onvergetelijke ervaringen wachten in Oeganda\'s adembenemende landschappen en levendige cultuur.',
      searchPlaceholder: 'Waar wil je naartoe?',
      categories: {
        all: 'Alles',
        wildlife: 'Wildlife',
        safari: 'Safari',
        cultural: 'Cultuur',
        adventure: 'Avontuur',
        birding: 'Vogels spotten'
      }
    },
    common: {
      from: 'vanaf',
      reviews: 'beoordelingen',
      viewMore: 'Meer weergeven',
      book: 'Boeken',
      seeAll: 'Alles bekijken',
      loading: 'Laden...'
    }
  }
};